module.exports = __webpack_public_path__ + "img/om.bbfc7725.svg";